import ReactGA from 'react-ga';

export const setGoogleAnalytics = (pageDetail) => {
    // ReactGA.initialize('UA-134724937-1', { debug: true, allowAnchor: true });
    // ReactGA.ga('set', 'transport', 'beacon');
    ReactGA.pageview(pageDetail);
}

export const setPageView = (pageDetail, location) => {
    ReactGA.ga('set', 'page', pageDetail);
    ReactGA.ga('set', 'location', location);
    ReactGA.ga('send', 'pageview');
}

export const setSearchTerm = (location) => {
    ReactGA.ga('set', 'page', location);
    ReactGA.ga('set', 'location', location);
    ReactGA.ga('send', 'pageview');
}

export const setUserId = (userInfo, userDetails) => {
    let regex = /@([^@]+)([^\.])\.([^\.]+)/g;
    let domain = (userDetails.eml).match(regex);
    if (domain[0].indexOf('@mailinator') == -1) {
        ReactGA.ga('set', 'userId', (userInfo.corporateName).replace(/ /g,''));
    } else {
         ReactGA.ga('set', 'userId', '');
    }
    return true
}

export const goolgeAnalyticsEvents = (category, label, action, value) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
        value: value
    });
}